/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InspectorControls, RichText } from '@wordpress/block-editor';
import { Panel, PanelBody, PanelRow, Button, ToggleControl } from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import '../index.css';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ clientId, attributes, setAttributes }) {
	const { title, button, blockId } = attributes

	const access_token = instagram_block.access_key
	const [posts, setPosts] = useState()

	useEffect(() => {
		fetch('https://graph.instagram.com/me/media?fields=id,media_url,permalink,username&limit=3&access_token=' + access_token)
			.then(res => res.json())
			.then(data => setPosts(data.data))
	}, [])

	const username = posts && posts[0].username

	if (!blockId) {
		setAttributes({ blockId: clientId })
	}

	const Elements = () => {
		return posts && posts.map((p) => {
			return (
				<a className="p-5 lg:p-0 aspect-square w-screen max-w-full hover:opacity-80 transition-all">
					<div className="bg-o-yellow bg-cover bg-center rounded-full w-full h-full mb-3" style={{ backgroundImage: `url(${p.media_url})` }}>

						<div className="w-full h-full rounded-full aspect-square relative">
							<div className='bg-o-red w-full h-full rounded-full aspect-square absolute -z-10 top-3 left-3'></div>
						</div>

					</div>
				</a>
			)
		})
	}

	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<Panel>

					<PanelBody title="Settings">
						<PanelRow>
							<ToggleControl
								checked={button || false}
								label="Show button"
								onChange={button => setAttributes({ button })}
							/>
						</PanelRow>
					</PanelBody>

					<PanelBody title="Instagram">
						<PanelRow>
							Changing the instagram account for this block is in the plugin's settings page:
						</PanelRow>
						<PanelRow>
							<Button variant="link" href={instagram_block.site_url + "/wp-admin/options-general.php?page=otweg_plugin"} target="_blank">Settings</Button>
						</PanelRow>
					</PanelBody>

				</Panel>
			</InspectorControls>

			<div className="my-20 max-w-screen lg:pl-10 lg:pr-12 xl:pl-0 xl:pr-0 relative">
				<RichText
					tagName='h1'
					value={title}
					allowedFormats={[]}
					onChange={(title) => setAttributes({ title })}
					placeholder="Insert title"
					className="text-4xl font-extrabold text-o-yellow text-center mb-10"
				/>

				<div className="relative overflow-x-auto flex items-center lg:justify-center lg:overflow-x-visible">

					<div className="block lg:hidden pointer-events-none mx-5">
						<div className="bg-o-blue h-10 text-white px-3 flex justify-center items-center rounded-full animate-bounce-vertical">
							<svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12l4-4m-4 4 4 4" />
							</svg>
							swipe
						</div>
					</div>

					<div id={"instagram-block-main-element-" + blockId} className="max-w-6xl min-w-6xl grid grid-cols-3 gap-10 relative overflow-x-auto lg:w-full lg:min-w-0 lg:inline lg:overflow-x-visible">

						<Elements />

					</div>

					<div className="block lg:hidden pointer-events-none mx-5">
						<div className="bg-o-blue h-10 text-white px-3 flex justify-center items-center rounded-full animate-bounce-vertical">
							swipe
							<svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
							</svg>
						</div>
					</div>

				</div>

				{button && (
					<div className="w-full flex justify-center">
						<div className="text-center mt-10">
							<a id="instagram-block-button-<?php echo $attributes['blockId'] ?>" target="_blank" className="inline-flex items-center whitespace-nowrap no-underline bg-o-red text-white text-lg px-5 py-2 rounded-full hover:cursor-pointer hover:opacity-80 transition-all mb-3 sm:mb-0">
								@{username}
								<svg className="w-6 h-6 ml-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
									<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
								</svg>
							</a>
						</div>
					</div>
				)}

			</div>

			{/* <div class="my-10 max-w-screen lg:pl-10 lg:pr-12 xl:pl-0 xl:pr-0 relative">
				<RichText
					tagName='h1'
					value={title}
					allowedFormats={[]}
					onChange={(title) => setAttributes({ title })}
					placeholder="Insert title"
					className="text-4xl font-extrabold text-o-yellow text-center mb-10"
				/>


				<div class="relative overflow-x-auto flex items-center lg:justify-center lg:overflow-x-visible">

					<div class="block lg:hidden pointer-events-none mx-5">
						<div class="bg-o-blue h-10 text-white px-3 flex justify-center items-center rounded-full animate-bounce-vertical">
							<svg class="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12l4-4m-4 4 4 4" />
							</svg>
							swipe
						</div>
					</div>

					<div id="instagram-block-main-element-<?php echo $attributes['blockId'] ?>" class="max-w-6xl min-w-6xl grid grid-cols-3 gap-10 relative overflow-x-auto lg:w-full lg:min-w-0 lg:inline lg:overflow-x-visible max-w-screen">

						<Elements />

					</div>

					<div class="block lg:hidden pointer-events-none mx-5">
						<div class="bg-o-blue h-10 text-white px-3 flex justify-center items-center rounded-full animate-bounce-vertical">
							swipe
							<svg class="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
							</svg>
						</div>
					</div>

				</div>


				{button && (
					<div class="w-full flex justify-center">
						<div class="text-center mt-10">
							<a id="instagram-block-button-<?php echo $attributes['blockId'] ?>" target="_blank" class="inline-flex items-center whitespace-nowrap no-underline bg-o-red text-white text-lg px-5 py-2 rounded-full hover:cursor-pointer hover:opacity-80 transition-all mb-3 sm:mb-0">
								@{username}
								<svg class="w-6 h-6 ml-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
									<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
								</svg>
							</a>
						</div>
					</div>
				)}

			</div> */}


		</div>
	);
}

// https://developers.facebook.com/docs/instagram-basic-display-api/guides/getting-access-tokens-and-permissions
